module.exports = __webpack_public_path__ + "static/media/background.18dc58ec.png";